<template>
  <div class="mask-overlay" aria-hidden="true">
    <span
      v-for="mask in masks"
      :key="mask.id"
      class="mask-overlay__item"
      :style="maskStyle(mask)"
    />
  </div>
</template>

<script setup lang="ts">
import type { CSSProperties } from 'vue'

import type { InteractionMask } from '../../data/home2026'

const props = defineProps<{
  masks: InteractionMask[]
  scaledPx: (value: number) => string
}>()

const maskStyle = (mask: InteractionMask): CSSProperties => ({
  left: props.scaledPx(mask.x),
  top: props.scaledPx(mask.y),
  width: props.scaledPx(mask.w),
  height: props.scaledPx(mask.h),
  borderRadius: props.scaledPx(mask.radius ?? 0),
})
</script>

<style scoped>
.mask-overlay {
  position: absolute;
  z-index: 1;
  inset: 0;
  pointer-events: none;
}

.mask-overlay__item {
  position: absolute;
  display: block;
  background: #000;
}
</style>
